import React from 'react'
import { Route, Switch } from 'react-router-dom'

import APPList from 'components/integrations/IntegrationAPPView/APPList'
import APPCreate from 'components/integrations/IntegrationAPPView/APPCreate'
import APPEdit from 'components/integrations/IntegrationAPPView/APPEdit'

const Metrics = ({ match }) => (
  <Switch>
    <Route path={`${match.path}/apps`} exact component={APPList} />
    <Route path={`${match.path}/apps/create`} exact component={APPCreate} />
    <Route path={`${match.path}/apps/:identifier`} exact component={APPEdit} />
  </Switch>
)

export default Metrics
